/* eslint-disable jsdoc/require-jsdoc */
import React, { useState } from 'react';
import CalendarPopup from './CalendarPopup';
import { getDateForCalendar } from '../../../../../utils/common';

function getDateTimeFromString(date) {
  if (!date) {
    return '';
  }

  return {
    date: getDateForCalendar(new Date(date)),
    time: date.split(' ')[1],
  };
}

function DateRange({ label, value, onChange }) {
  const [calendarPopupIsOpen, setCalendarPopupIsOpen] = useState(false);

  function handleDateSelection(selectedDate) {
    onChange(selectedDate);
  }

  return (
    <div className="filter__field">
      <label className="filter__field-label">{label}</label>

      <div className={`filter__field-input hasCalendar ${calendarPopupIsOpen ? 'open' : ''}`}>
        <div className="mask" />
        <div className="filter__field-input-toggle" onClick={() => setCalendarPopupIsOpen((prev) => !prev)}>
          <span className="filter__field-input-date">
            <div>
              From:
              <span className="m-l-10">
                <span>{getDateTimeFromString(value.from).date}</span>
                <span className="m-l-10">{getDateTimeFromString(value.from).time}</span>
              </span>
            </div>
            <div>
              To:
              <span className="m-l-20">
                <span>{getDateTimeFromString(value.to).date}</span>
                <span className="m-l-10">{getDateTimeFromString(value.to).time}</span>
              </span>
            </div>
          </span>
          <span className="calendar-icon" />
        </div>
        <CalendarPopup
          onChangeDate={handleDateSelection}
          onClose={setCalendarPopupIsOpen.bind(null, false)}
        />
      </div>
    </div>

  );
}

export default DateRange;
